module.exports = __webpack_public_path__ + "static/media/cyano.ceb1c3ae.svg";